import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { ContestStorySapphire } from '~/atomic/page/contest/ContestStorySapphire';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const ContestEverythingWillBeFinePage: NextPage & LayoutType = () => {
  const title = 'Конкурс рассказов Сапфир';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.contestStorySapphire.isPublic}
      seo={{
        title,
        image: `${process.env.NEXT_PUBLIC_BASE_FRONT_URL}/image/contest/story-sapphire/banner.jpg`,
        canonical: pagesConfigStore.contestStorySapphire.url,
      }}
      content={(
        <ContestStorySapphire />
      )}
    />
  );
};

ContestEverythingWillBeFinePage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (ctx) => {
  const { store, dispatch } = await createStore();
  const isLoggedIn = await checkAuthToken(ctx, dispatch);

  const state = store.getState();

  return { props: { state } };
};

export default ContestEverythingWillBeFinePage;
